import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f60fbde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-buttons" }


import {ButtonSetting} from "@/components/business/crud/widgets/TableWidgetContainer";


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetTableButton',
  props: {
    buttons: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_sc_btn = _resolveComponent("sc-btn")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_space, { size: "small" }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (button, key) => {
          return (_openBlock(), _createBlock(_component_sc_btn, _mergeProps({ key: key }, button), null, 16))
        }), 128)),
        _renderSlot(_ctx.$slots, "right")
      ]),
      _: 3
    })
  ]))
}
}

})